import React from 'react';
import { Link } from 'react-router-dom';

export default function Availability() {
  return (
    <section className="availability-section">
      <p>
        I'm available for commission work and employment opportunities.<br />
        {' '}<Link to="/contact">Get in touch</Link> to discuss your project or role.
      </p>
    </section>
  );
}

